export default {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
};
